// import React from "react";
// import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
// import Login from "./components/Login";
// import TrainingManagement from "./components/TrainingManagement";
// import TrainingQuestions from "./components/TrainingQuestions";
// import ViewTrainings from "./components/ViewTrainings";
// import ViewTrainingQuestions from "./components/ViewTrainingQuestion"; 
// import NotFound from "./components/NotFound";
// import ViewResults from "./components/ViewResults";
// import ViewTrainingResults from "./components/ViewTrainingResults";
// import TopBar from "./components/TopBar"; 
// import SignUp from "./components/SignUp";
// import { auth } from "./firebase";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// const App = () => {
//   const [isAuthenticated, setIsAuthenticated] = React.useState(false);
//   const [userName, setUserName] = React.useState("");

//   // Listen for auth state changes
//   React.useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       if (user) {
//         setIsAuthenticated(true);
//         setUserName(user.displayName || "User");
//       } else {
//         setIsAuthenticated(false);
//         setUserName("");
//       }
//     });
//     return unsubscribe;
//   }, []);

//   const handleLogout = () => {
//     auth.signOut(); // Sign out the user
//     setIsAuthenticated(false);
//     setUserName(""); // Clear user data
//   };

//   return (
//     <Router>
//       <div>
//         {isAuthenticated && <TopBar userName={userName} onLogout={handleLogout} />}

//         <Routes>
//           {/* Redirect to dashboard if authenticated, otherwise show Login */}
//           <Route
//             path="/"
//             element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
//           />

//           {/* Protected Route for /dashboard */}
//           <Route
//             path="/manage-training"
//             element={isAuthenticated ? <TrainingManagement /> : <Login />}
//           />

//           {/* Protected Route for training questions */}
//           <Route
//             path="/training-questions/:trainingId"
//             element={isAuthenticated ? <TrainingQuestions /> : <Login/>}
//           />

//           {/* New Route for Viewing Trainings */}
//           <Route
//             path="/dashboard"
//             element={isAuthenticated ? <ViewTrainings /> : <Login/>}
//           />

//           {/* New Route for Viewing Training Questions for a specific Training */}
//           <Route
//             path="/view-training-questions/:trainingId"
//             element={isAuthenticated ? <ViewTrainingQuestions /> : <Login/>}
//           />

//           {/* Sign Up route */}
//           <Route
//             path="/signup"
//             element={!isAuthenticated ? <SignUp /> : <Navigate to="/" />}
//           />

//           {/* Catch-all route for 404 Not Found */}
//           <Route path="*" element={<NotFound />} />

//           <Route
//             path="/view-results"
//             element={isAuthenticated ? <ViewResults/> : <Login />}
//           />

//           <Route
//             path="/view-training-result/:userId/:quizId"
//             element={isAuthenticated ? <ViewTrainingResults/> : <Login />}
//           />


//         </Routes>

//         {/* Toast notifications */}
//         <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
//       </div>
//     </Router>
//   );
// };

// export default App;





import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import Login from "./components/Login";
import TrainingManagement from "./components/TrainingManagement";
import TrainingQuestions from "./components/TrainingQuestions";
import ViewTrainings from "./components/ViewTrainings";
import ViewTrainingQuestions from "./components/ViewTrainingQuestion";
import RetakeTraining from "./components/RetakeTraining" 
import NotFound from "./components/NotFound";
import ViewResults from "./components/ViewResults";
import ViewTrainingResults from "./components/ViewTrainingResults";
import ViewRetakeTrainingResults from "./components/ViewRetakeTrainingResult";
import TopBar from "./components/TopBar"; 
import SignUp from "./components/SignUp";
import Feedback from "./components/Feedback";
import ViewFeedback from "./components/ViewFeedback";
import { auth } from "./firebase";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Separate component to manage TopBar and Routes
const AppContent = ({ isAuthenticated, userName, userEmail, handleLogout }) => {
  const location = useLocation(); // Safe to use inside Router

  const allowedEmails = ["mobeensafdar2020@gmail.com", "bismillah.alam@beescare.co.uk"];

  return (
    <div>
      {/* Display TopBar unless the URL contains "view-results" */}
      {isAuthenticated && !location.pathname.includes("view-training-result") && (
        <TopBar userName={userName} userEmail={userEmail} onLogout={handleLogout} />
      )}

      <Routes>
        {/* Redirect to dashboard if authenticated, otherwise show Login */}
        <Route
          path="/"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
        />

        {/* Protected Route for /dashboard */}
        <Route
          path="/manage-training"
          element={isAuthenticated && allowedEmails.includes(userEmail) ? <TrainingManagement /> : <Login />}
        />

        {/* Protected Route for training questions */}
        <Route
          path="/training-questions/:trainingId"
          element={isAuthenticated ? <TrainingQuestions /> : <Login/>}
        />

        {/* New Route for Viewing Trainings */}
        <Route
          path="/dashboard"
          element={isAuthenticated ? <ViewTrainings /> : <Login/>}
        />

        {/* New Route for Viewing Training Questions for a specific Training */}
        <Route
          path="/view-training-questions/:trainingId"
          element={isAuthenticated ? <ViewTrainingQuestions /> : <Login/>}
        />

<Route
          path="/retake-training-questions/:trainingId"
          element={isAuthenticated ? <RetakeTraining /> : <Login/>}
        />

        {/* Sign Up route */}
        <Route
          path="/signup"
          element={!isAuthenticated ? <SignUp /> : <Navigate to="/" />}
        />

        {/* Catch-all route for 404 Not Found */}
        <Route path="*" element={<NotFound />} />

        <Route
          path="/view-results"
          element={isAuthenticated ? <ViewResults/> : <Login />}
        />

      <Route
          path="/feedback/:trainingId"
          element={isAuthenticated ? <Feedback/> : <Login />}
        />

<Route
          path="/view-feedback/:userId/:quizId"
          element={isAuthenticated ? <ViewFeedback/> : <Login />}
        />

        <Route
          path="/view-training-result/:userId/:quizId"
          element={isAuthenticated ? <ViewTrainingResults/> : <Login />}
        />

<Route
          path="/view-retake-training-result/:userId/:trainingId"
          element={isAuthenticated ? <ViewRetakeTrainingResults/> : <Login />}
        />

      </Routes>
    </div>
  );
};




const App = () => {
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [userName, setUserName] = React.useState("");
  const [userEmail, setUserEmail] = React.useState("");

  // Listen for auth state changes
  React.useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setIsAuthenticated(true);
        setUserName(user.displayName || "User");
        setUserEmail(user.email || ""); // Get the user's email
      } else {
        setIsAuthenticated(false);
        setUserName("");
        setUserEmail(""); // Clear email when logged out
      }
    });
    return unsubscribe;
  }, []);

  const handleLogout = () => {
    auth.signOut(); // Sign out the user
    setIsAuthenticated(false);
    setUserName(""); // Clear user data
    setUserEmail(""); // Clear user email
  };

  return (
    <Router>
      <AppContent
        isAuthenticated={isAuthenticated}
        userName={userName}
        userEmail={userEmail} // Pass the email
        handleLogout={handleLogout}
      />
      {/* Toast notifications */}
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
    </Router>
  );
};



export default App;
